module.exports = __webpack_public_path__ + "img/426.dce55e84.jpg";